import { shortcuts } from "@/input/shortcuts";
import { type DocumentModel } from "@/models/DocumentModel";
import { buildKeyCombinations } from "@/utils/keyMatcher";

/**
 * Trigger a keyboard shortcut handler directly without the include check.
 * Use it for edge cases.
 *
 * @param cursor - Active cursor.
 * @param key - The keyboard key string.
 */
export function triggerKeyboardInput(doc: DocumentModel, key: string, event: KeyboardEvent): void {
  const shortcut = shortcuts[key];

  if (shortcut) {
    shortcut.action(doc, { event });
  }
}

export function getKeyboardInputShortcut(e: KeyboardEvent | React.KeyboardEvent<HTMLInputElement>) {
  const combinations = buildKeyCombinations(e);
  /**
   * `combinations` can include key code combinations (`Shift+Digit6`) or symbols (`^`).
   * Key combinations have a priority over symbols.
   */
  return combinations.map((comb) => shortcuts[comb]).find(Boolean);
}
